import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'

import Swal from 'sweetalert2'
import {useMutation, useQueryClient} from 'react-query'
import * as bootstrap from 'bootstrap'
import getBroker from '../server/Step8'
import {showToast} from '../middleware/showToast'
import {
  IProfileDetails,
  profileDetailsInitValues as initialValues,
} from '../../../accounts/components/settings/GetBroker'
import {QrMkt} from '../../../wizards/components/steps/ModalReaded/QrMkt'

const profileDetailsSchema = Yup.object().shape({
  nameBorker: Yup.string().required('Tên broker is required'),
  branchCode: Yup.string().required('Branch code is required'),
})

const QrForMarketing: React.FC = () => {
  const [valueBrcd, setValueBrcd] = useState('')
  const [valueNameBro, setValueNameBro] = useState('')
  const [loading, setLoading] = useState(false)
  const queryClient = useQueryClient()

  const {mutate} = useMutation(getBroker, {
    onSuccess: (data) => {
      if (data.data_list[0].code_nm) {
        setLoading(false)
        return new bootstrap.Modal('#kt_modal_3', {
          backdrop: 'static',
          keyboard: false,
        }).show()
      }
      if (data.data_list[0].chk) {
        setLoading(false)
        Swal.fire({
          title: 'Không tồn tại nhân viên môi giới',
          allowOutsideClick: false,
          html: `Vui lòng liên hệ NHSV theo số
                  <b>19001055</b>
                 để biết thêm chi tiết.`,
          icon: 'error',
          confirmButtonText: 'Thử lại',
        })
      }
    },
    onError: (error: any) => {
      setLoading(false)
      showToast('Liên hệ Admin', 1500, 'error')
    },
    onSettled: () => {
      queryClient.invalidateQueries('create-qr')
    },
  })

  const formik = useFormik<IProfileDetails>({
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: (values) => {
      setValueNameBro(values.nameBorker)
      setValueBrcd(values.branchCode)
      setLoading(true)
      const request = {
        brch_cd: values.branchCode,
        emp_no: values.nameBorker,
      }
      mutate(request)
    },
  })

  return (
    <div>
      <form onSubmit={formik.handleSubmit} noValidate className='form'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              <span className='required'>Tên marketing</span>
            </label>

            <div className='col-lg-8 fv-row'>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                placeholder='Nhập tên broker'
                {...formik.getFieldProps('nameBorker')}
              />
              {formik.touched.nameBorker && formik.errors.nameBorker && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors.nameBorker}</div>
                </div>
              )}
            </div>
          </div>

          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              <span className='required'>Branch code</span>
            </label>

            <div className='col-lg-8 fv-row'>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                placeholder='Nhập tên branch code'
                {...formik.getFieldProps('branchCode')}
              />
              {formik.touched.branchCode && formik.errors.branchCode && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors.branchCode}</div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button type='submit' className='btn btn-primary' disabled={loading}>
            {!loading && 'Create'}
            {loading && (
              <span className='indicator-label' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </form>

      <QrMkt valueBrcd={valueBrcd} valueNameBro={valueNameBro} />
    </div>
  )
}

export {QrForMarketing}
